import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const BeforePublicationViewU = () => {
  const { id } = useParams();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublication = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/${id}`);
        setPublication(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching publication:', err);
        setLoading(false);
      }
    };

    fetchPublication();
  }, [id]);

  

  if (loading) return <p>Loading...</p>;
  if (!publication) return <p>No publication found.</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow p-4">
        <h3 className="text-primary mb-3 text-center">Before Publication Details</h3>

        <div className="mb-3">
          <strong>Claimed By User ID:</strong>
          <div>{publication.claimedId}</div>
        </div>

        <div className="mb-3">
          <strong>Paper Title:</strong>
          <div>{publication.paperTitle}</div>
        </div>

        <div className="mb-3">
          <strong>Journal Name:</strong>
          <div>{publication.journalName}</div>
        </div>

        <div className="mb-3">
          <strong>Status:</strong>
          <div className={
  publication.status === '1'
    ? 'text-success'
    : publication.status === '2'
    ? 'text-danger'
    : 'text-warning'
}>
  {publication.status === '1'
    ? 'Approved'
    : publication.status === '2'
    ? 'Rejected'
    : 'Not Approved'}
</div>

        </div>

        <div className="mb-3">
          <strong>Citation References:</strong>
          <ul className="list-group">
            {publication.citations.map((cite, i) => (
              <li key={i} className="list-group-item">{cite}</li>
            ))}
          </ul>
        </div>

        
      </div>
    </div>
  );
};

export default BeforePublicationViewU;
